import { PaymentMethodType } from '../../gql/globalTypes';
export function buildAdobeOrderConfirmationPayload(subscripiton) {
  var methodOfPayment = subscripiton.methodOfPayment,
    sourceVendor = subscripiton.sourceVendor,
    promotionRedemptions = subscripiton.promotionRedemptions,
    invoices = subscripiton.invoices,
    vendorPlan = subscripiton.vendorPlan;
  var _ref = invoices !== null && invoices !== void 0 && invoices.length ? invoices[0] : {},
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? '' : _ref$currency,
    _ref$subTotal = _ref.subTotal,
    subTotal = _ref$subTotal === void 0 ? '0' : _ref$subTotal,
    _ref$tax = _ref.tax,
    tax = _ref$tax === void 0 ? '0' : _ref$tax,
    _ref$totalAmount = _ref.totalAmount,
    totalAmount = _ref$totalAmount === void 0 ? '0' : _ref$totalAmount;
  var vendorSubscriptionId = sourceVendor.vendorSubscriptionId;
  var _ref2 = promotionRedemptions !== null && promotionRedemptions !== void 0 && promotionRedemptions.length ? promotionRedemptions[0] : {},
    _ref2$code = _ref2.code,
    promotionCode = _ref2$code === void 0 ? 'n/a' : _ref2$code,
    _ref2$discountAmount = _ref2.discountAmount,
    discountAmount = _ref2$discountAmount === void 0 ? '0' : _ref2$discountAmount;
  var _ref3 = methodOfPayment || {},
    mopInfo = _ref3.mopInfo,
    billingAddress = _ref3.billingAddress;
  var _ref4 = mopInfo || {},
    _ref4$type = _ref4.type,
    mopType = _ref4$type === void 0 ? PaymentMethodType.CREDIT_CARD : _ref4$type;
  var _ref5 = billingAddress || {},
    _ref5$state = _ref5.state,
    state = _ref5$state === void 0 ? '' : _ref5$state,
    _ref5$postalCode = _ref5.postalCode,
    postalCode = _ref5$postalCode === void 0 ? '' : _ref5$postalCode,
    _ref5$city = _ref5.city,
    city = _ref5$city === void 0 ? '' : _ref5$city,
    _ref5$country = _ref5.country,
    country = _ref5$country === void 0 ? '' : _ref5$country;
  var _ref6 = vendorPlan || {},
    _ref6$code = _ref6.code,
    planCode = _ref6$code === void 0 ? '' : _ref6$code,
    _ref6$family = _ref6.family,
    productFamily = _ref6$family === void 0 ? '' : _ref6$family;
  var productName = AdobeProductNameMap.get(productFamily) || '';
  var pageName = "".concat(productName.toUpperCase(), " Order Confirm Pixel");
  return {
    page: {
      pageInfo: {
        experience: 'desktop',
        pageName: pageName,
        pageNameDetailed: pageName
      },
      category: {
        primaryCategory: 'chegg',
        subCategory1: 'web',
        subCategory2: productName.toLowerCase()
      }
    },
    transaction: {
      attributes: {
        paymentMethod: RecurlyPaymentTypesToRioMap.get(mopType),
        affiliateID: null,
        conversionType: 'SINGLE_ITEM_PURCHASE',
        orderType: null
      },
      total: {
        voucherCode: promotionCode,
        voucherDiscount: discountAmount,
        total: totalAmount,
        currency: currency,
        shippingPaid: '0.00',
        taxPaid: tax,
        subtotal: subTotal,
        shippingMethod: 'n/a'
      },
      transactionID: vendorSubscriptionId,
      profile: {
        billingAddress: {
          postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : '',
          country: country,
          city: city !== null && city !== void 0 ? city : '',
          stateProvince: state !== null && state !== void 0 ? state : '',
          line1: '',
          line2: ''
        }
      },
      item: [{
        productInfo: {
          productID: planCode,
          stockStatus: 'In Stock',
          productFormat: productFamily,
          rentalTimeFrame: 'n/a'
        },
        quantity: 1,
        price: {
          basePrice: subTotal,
          currency: currency
        }
      }]
    }
  };
}
export var AdobeProductNameMap = new Map([['chegg_study_pack', 'bundle'], ['chegg_study', 'cs']]);
export var RecurlyPaymentTypesToRioMap = new Map([['CREDIT_CARD', 'Credit Card'], ['APPLE_PAY', 'ApplePay'], ['BRAINTREE_APPLE_PAY', 'ApplePay'], ['PAYPAL', 'Paypal'], ['BRAINTREE_V_ZERO', 'Paypal'], ['VENMO', 'Venmo'], ['GOOGLE_PAY', 'Gpay']]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/AdobeUtils/index.js
// module id = 4167
// module chunks = 11